var path = '/javascript/common/directives/orderInfo.html';
var html = "\n<p>\n    {{ $ctrl.getOrderTimePrefixString() }} <strong ng-class=\"$ctrl.getOrderHasEstimate() ? 'order-time' : 'text-success'\">{{ $ctrl.getOrderTimeString() }}</strong>\n</p>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;